export const YEAR = [{ label: '2026', value: 2026 }, { label: '2025', value: 2025 }];
export const DEFAULT_MONTH = 3;
export const DEFAULT_YEAR = 2026;

export const chartColorPalettes = {
  factory: ['#4f6af2', '#35a57f', '#7c4dff', '#d97706', '#dc2626', '#3ba3ec'],
  onshore: ['#4f6af2', '#35a57f', '#6d4cf5', '#d97706', '#dc2626', '#3ba3ec'],
  service: ['#d97706', '#6d4cf5', '#3ba3ec', '#4f6af2', '#dc2626', '#35a57f'],
};

export const segmentStyles = {
  Factory: {
    accent: 'bg-gradient-to-r from-[#00C6A2] to-[#0060D0]', // Gradient
    icon: '🏭',
  },
  Onshore: {
    accent: 'bg-[#00C6A2]', // Forest
    icon: '🏗️',
  },
  Service: {
    accent: 'bg-[#0060D0]', // Teal
    icon: '🛠️',
  },
};

export const defaultSummaryCards = [
  {
    title: 'Factory',
    accent: segmentStyles.Factory.accent,
    icon: segmentStyles.Factory.icon,
    baselinePerYear: 45.83,
    metrics: [
      { label: 'Actual Per Month', value: 2.37 },
      { label: 'Baseline Per Month', value: 3.83 },
      { label: 'Target Per Month', value: 3.83 },
    ],
    xlsLink: null,
  },
  {
    title: 'Onshore',
    accent: segmentStyles.Onshore.accent,
    icon: segmentStyles.Onshore.icon,
    baselinePerYear: 75.46,
    metrics: [
      { label: 'Actual Per Month', value: 316.33 },
      { label: 'Baseline Per Month', value: 6.28 },
      { label: 'Target Per Month', value: 3.16 },
    ],
    xlsLink: null,
  },
  {
    title: 'Service',
    accent: segmentStyles.Service.accent,
    icon: segmentStyles.Service.icon,
    baselinePerYear: 205.2,
    metrics: [
      { label: 'Actual Per Month', value: 20.1 },
      { label: 'Baseline Per Month', value: 17.1 },
      { label: 'Target Per Month', value: 11.26 },
    ],
    xlsLink: null,
  },
];

export const defaultDonutSections = [
  {
    title: 'Factory - cost split by BP category',
    subtitle: 'Actuals Rs Cr',
    total: 2.37,
    centerLabel: 'Rs Cr total',
    items: [
      { name: 'Facility Management Costs', value: 0.96, color: '#4f6af2' },
      { name: 'Insurance', value: 0.15, color: '#35a57f' },
      {
        name: 'Warehouse operations expenses & Consumables',
        value: 0.43,
        color: '#7c4dff',
      },
      { name: 'Repair & Maintenance', value: 0.04, color: '#d97706' },
      { name: 'Others', value: 0.79, color: '#dc2626' },
    ],
  },
  {
    title: 'Onshore - cost split by BP category',
    subtitle: 'Actuals Rs Cr',
    total: 316.33,
    centerLabel: 'Rs Cr total',
    items: [
      { name: 'Facility Management Costs', value: 316.56, color: '#4f6af2' },
      { name: 'Insurance', value: 0.42, color: '#35a57f' },
      {
        name: 'Warehouse operations expenses & Consumables',
        value: -2.77,
        color: '#6d4cf5',
      },
      { name: 'Repair & Maintenance', value: 0.46, color: '#d97706' },
      { name: 'Others', value: 1.66, color: '#dc2626' },
    ],
  },
  {
    title: 'Service - cost split by BP category',
    subtitle: 'Actuals Rs Cr',
    total: 20.1,
    centerLabel: 'Rs Cr total',
    items: [
      { name: 'Manpower & Security', value: 15.13, color: '#d97706' },
      { name: 'Insurance & Medical Checkup', value: 1.77, color: '#6d4cf5' },
      { name: 'Travel & Logistics', value: 2.46, color: '#3ba3ec' },
      { name: 'BOP', value: 0.04, color: '#4f6af2' },
      {
        name: 'SCADA & IT Communication, Training, Safety, Tools & Site Expenses',
        value: 0.7,
        color: '#dc2626',
      },
      { name: 'Rent & Compliance', value: 0, color: '#35a57f' },
    ],
  },
];

export const defaultTrendSeries = {
  labels: ['Jan-2026', 'Feb-2026', 'Mar-2026'],
  factory: [0, -2.41, 2.37],
  onshore: [0, 105.43, 316.33],
  service: [0, 48.45, 20.1],
};

export const formatDashboardTitle = (name) =>
  name
    ?.toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase()) || 'Dashboard Detail';

export const formatValue = (value) => Number(value || 0).toFixed(2);


export const mapChartItems = (items = [], palette = []) =>
  items.map((item, index) => ({
    name: item.Category,
    value: Number(item.ActualValue || 0),
    color: palette[index % palette.length],
  }));

export const buildSummaryCard = (
  cardData,
  fallbackTitle,
  accent,
  icon,
  excelFiles = []
) => {
  const title =
    cardData?.card1 || cardData?.card2 || cardData?.card3 || fallbackTitle;
  const lowerCaseFallbackTitle = fallbackTitle.toLowerCase();
  const excelFile = excelFiles.find((file) =>
    file.id.toLowerCase().includes(lowerCaseFallbackTitle)
  );

  return {
    title,
    accent,
    icon,
    xlsLink: excelFile?.xlsLink || null,
    baselinePerYear: Number(cardData?.BaselinePerYear || 0),
    metrics: [
      {
        label: 'Actual Per Month',
        value: Number(cardData?.ActualPerMonth || 0),
      },
      {
        label: 'Baseline Per Month',
        value: Number(cardData?.BaselinePerMonth || 0),
      },
      {
        label: 'Target Per Month',
        value: Number(cardData?.TargetPerMonth || 0),
      },
    ],
  };
};

export const buildDashboardData = (items, selectedMonth, selectedYear) => {
  const factoryCard = items?.card1?.[0] || {};
  const onshoreCard = items?.card2?.[0] || {};
  const serviceCard = items?.card3?.[0] || {};
  const excelFiles = items?.excelFiles || [];

  return {
    summaryCards: [
      buildSummaryCard(
        factoryCard,
        'Factory',
        segmentStyles.Factory.accent,
        segmentStyles.Factory.icon,
        excelFiles
      ),
      buildSummaryCard(
        onshoreCard,
        'Onshore',
        segmentStyles.Onshore.accent,
        segmentStyles.Onshore.icon,
        excelFiles
      ),
      buildSummaryCard(
        serviceCard,
        'Service',
        segmentStyles.Service.accent,
        segmentStyles.Service.icon,
        excelFiles
      ),
    ],
    donutSections: [
      {
        title: 'Factory - cost split by BP category',
        subtitle: 'Actuals Rs Cr',
        total: Number(items?.chart1?.[0]?.ActualTotalValue || 0),
        centerLabel: 'Rs Cr total',
        items: mapChartItems(items?.chart1, chartColorPalettes.factory),
      },
      {
        title: 'Onshore - cost split by BP category',
        subtitle: 'Actuals Rs Cr',
        total: Number(items?.chart2?.[0]?.ActualTotalValue || 0),
        centerLabel: 'Rs Cr total',
        items: mapChartItems(items?.chart2, chartColorPalettes.onshore),
      },
      {
        title: 'Service - cost split by BP category',
        subtitle: 'Actuals Rs Cr',
        total: Number(items?.chart3?.[0]?.ActualTotalValue || 0),
        centerLabel: 'Rs Cr total',
        items: mapChartItems(items?.chart3, chartColorPalettes.service),
      },
    ],
    trendSeries: {
      labels: (items?.chart4 || []).map((entry) => entry.MonthYear),
      factory: (items?.chart4 || []).map((entry) =>
        Number(entry.FactoryActual || 0)
      ),
      onshore: (items?.chart4 || []).map((entry) =>
        Number(entry.OnshoreActual || 0)
      ),
      service: (items?.chart4 || []).map((entry) =>
        Number(entry.ServiceActual || 0)
      ),
    },
    excelFiles,
  };
};
